import axios from "axios" ;
import qs from "qs";
import vuex from 'vuex';
import {mapGetters} from "vuex";
import Cookies from 'js-cookie'
import {getToken, setToken, removeToken} from '../request/toekn'
import global from './global'
import {Notification,MessageBox,Message,} from 'element-ui';
// console.log(process.env.VUE_APP_BASE_API, '888');


// 环境的切换
// axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
// axios.defaults.baseURL = 'https://api.oceanscm.com/';//测试环境
axios.defaults.baseURL = 'https://api.idalc.com/';//正式环境
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// request 是请求服务器执行的拦截函数
axios.interceptors.request.use(function (config) {
    if (config.method == "post") {
        config.data = qs.stringify(config.data)
    }
    if (Cookies.get(getToken()) && getToken()) {
        config.headers[getToken()] = Cookies.get(getToken());
    }
    return config;
}, function (error) {
    // 对请求失败做处理
    return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {

    if(response.data.code==1){
        global.TokenInvalidFlag=0;
        return response
    }
    else if(response.data.code==8000){
        if(global.TokenInvalidFlag==0){
            Message({
                type:'error',
                message:'请重新登录！'
            });
            Cookies.remove(getToken());
            Cookies.remove('cate');
            Cookies.remove('chat_user');
            Cookies.remove('chat_token');
            window.localStorage.clear();
            global.TokenInvalidFlag=1;
            setTimeout(()=>{
                window.location.reload()
            },1500)
        }
    }
    else if (response.data.code==8101){
        if(global.TokenInvalidFlag==0){

            Message({
                type:'error',
                message:'系统检测到多个设备同时登录同一个账号，为保证您的账号安全，请重新登录！'
            });
            Cookies.remove(getToken());
            Cookies.remove('cate');
            Cookies.remove('chat_user');
            Cookies.remove('chat_token');
            window.localStorage.clear();
            global.TokenInvalidFlag=1;

            setTimeout(()=>{
                window.location.reload()
            },1500)
        }
    }
    else {
        return response
    }

}, function (error) {
    return Promise.reject(error);
});



export default axios
